import type { Account } from './account';
import type { AccountGroup } from './accountGroup';
import type { BillingSchedule } from './billingSchedule';
import type { FeeTier } from './feeTier';
import type { Organization } from './organization';
import type { PhysicalAddress } from './physicalAddress';
import type { Relationship } from './relationship';
import type { Statistics } from './stats';
import type { User } from './user';

type Maybe<T> = T | null;

export enum ClientGroupTypes {
  Business = 'BUSINESS',
  Household = 'HOUSEHOLD',
}

export enum ClientGroupMemberAccessTypes {
  View = 'VIEW',
  NoAccess = 'NO_ACCESS',
}

export enum CorporateBusinessTypes {
  Corporation = 'CORPORATION',
  Llc = 'LLC',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
}

enum CorporateCountries {
  Ca = 'CA',
  Usa = 'USA',
}

export enum ClientGroupStates {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export type ClientGroup = {
  id: string;
  accounts?: Account[];
  accountGroups?: AccountGroup[];
  allIncompleteFormAgreements?: [];
  billingSchedule?: Maybe<BillingSchedule>;
  businessIsMemberOfIiroc?: Maybe<boolean>;
  businessType?: Maybe<CorporateBusinessTypes>;
  completedAt?: Maybe<string>;
  corporationCountry?: Maybe<CorporateCountries>;
  establishedDate?: Maybe<string>;
  feeTier?: Maybe<FeeTier>;
  incompleteFields?: Maybe<string[]>;
  incorporationNumber?: Maybe<string>;
  name: string;
  organization?: Maybe<Organization>;
  phone?: Maybe<string>;
  physicalAddress?: Maybe<PhysicalAddress>;
  primaryEmail?: Maybe<string>;
  primaryUser: User;
  relationships: Relationship[];
  taxNumber?: Maybe<string>;
  type: ClientGroupTypes;
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  statistics?: Statistics;
  custodianStatistics?: Statistics;
  state: ClientGroupStates;
  availableCurrencies?: string[];
};
